module.exports = __webpack_public_path__ + "img/coinbankB16.c26787f6.jpg";